 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"404":"404","CE":"CE","D_Cnf":"D_Cnf","D_Faq":"D_Faq","D_Lty":"D_Lty","D_Prs":"D_Prs","G~H~Ordr~P~Pay~St":"G~H~Ordr~P~Pay~St","G~H~P~Pay":"G~H~P~Pay","G~Pay":"G~Pay","G":"G","Pay":"Pay","P":"P","zav_c":"zav_c","H":"H","Ordr":"Ordr","St":"St","LK":"LK","LK_A":"LK_A","LK_B":"LK_B","LK_D":"LK_D","LK_Da":"LK_Da","LK_M":"LK_M","LK_O":"LK_O","LK_S":"LK_S","M_C":"M_C","M_C_E":"M_C_E","M_F_F":"M_F_F","M_N_Y":"M_N_Y","M_O_C":"M_O_C","M_P_A":"M_P_A","M_P_O":"M_P_O","M_S_C":"M_S_C","M_S_O~Stts":"M_S_O~Stts","M_S_O":"M_S_O","Stts":"Stts","M_V":"M_V","Mdcns":"Mdcns","O_Pmnt":"O_Pmnt","WH":"WH","biv_c":"biv_c","ch_c":"ch_c","hal_c":"hal_c","ig_c":"ig_c","iv_c":"iv_c","led_c":"led_c","m_c":"m_c","mar_c":"mar_c","mr_c":"mr_c","nan_c":"nan_c","pet_c":"pet_c","pic_c":"pic_c","ugr_c":"ugr_c","xd_c":"xd_c","zavtra-eol":"zavtra-eol"}[chunkId]||chunkId) + ".js?v=" + {"404":"498f478d","CE":"a363dd62","D_Cnf":"6648c81e","D_Faq":"d4eb02e8","D_Lty":"4a8f3445","D_Prs":"6d3e1d53","G~H~Ordr~P~Pay~St":"cd741562","G~H~P~Pay":"3effc6ea","G~Pay":"a47ec86a","G":"efbb0bd4","Pay":"0f426fe2","P":"58629be4","zav_c":"f11da2a8","H":"24592d16","Ordr":"589d4892","St":"117f65ba","LK":"cebba098","LK_A":"62019823","LK_B":"2da8e4cc","LK_D":"700b4736","LK_Da":"e2360c15","LK_M":"a02b60c9","LK_O":"26b2ee1a","LK_S":"b21ea583","M_C":"b114a88d","M_C_E":"8b570586","M_F_F":"47a0dd82","M_N_Y":"c6c46f84","M_O_C":"f4c07711","M_P_A":"1b1aaa9d","M_P_O":"55e7024e","M_S_C":"046cd89f","M_S_O~Stts":"fdff0c67","M_S_O":"3cb2ad90","Stts":"e362688c","M_V":"e66c4bba","Mdcns":"ea0c4634","O_Pmnt":"3c07c7e9","WH":"60b313f3","biv_c":"883a247d","ch_c":"7a296010","hal_c":"af6b8d31","ig_c":"59ecaba9","iv_c":"c5d2f8a3","led_c":"1d2e7fcb","m_c":"1295cd83","mar_c":"a03a77ef","mr_c":"e15726a9","nan_c":"06f2b90e","pet_c":"6c747711","pic_c":"72108c80","ugr_c":"197b5993","xd_c":"27a98246","zavtra-eol":"3c6312a9"}[chunkId] + ""
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/legacy/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
